import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { FilterIcon } from './WorkflowPanel';
/**
 * Shared issue filter button (extension Issues tab, Team Review panel); each surface owns menu dismissal.
 * An icon-only square beside the search field (Emily, 2026-10-30, prototype docs/prototypes/quieter-issue-lists):
 * the count, the shipped Filter count with the Active issues default left out, sits in a corner badge and the button
 * itself never tints. Styles: issueListControls.css.
 */
export const FilterTrigger = forwardRef(function FilterTrigger({ count, expanded, ...props }, ref) {
    return _jsxs("button", { ...props, ref: ref, type: "button", className: "oq-dropdown__filter-btn oq-filter-trigger oq-filter-trigger--icon", "aria-label": "Filter issues", "aria-expanded": expanded, "aria-haspopup": "dialog", children: [_jsx(FilterIcon, {}), count > 0 && _jsx("span", { className: "oq-filter-trigger__count", "aria-hidden": "true", children: count })] });
});
//# sourceMappingURL=FilterTrigger.js.map